module.exports = __webpack_public_path__ + "img/prize_1.aaf83695.gif";